var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"d2-mr btn-text can-hover",attrs:{"type":"text"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"iconfont iconnav_sousuo",staticStyle:{"font-size":"16px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }